(function ($) {
    function productSlider() {
        $(".product-slider:not(.products__slider-editor)").each(function () {
            var $this = $(this);
            var Products = new Swiper($this.find('.swiper-container')[0], {
                slidesPerView: 2,
                loop: false,
                spaceBetween: 8,
                freeMode: true,
                observer: true,
                watchOverflow: true,
                watchSlidesVisibility: true,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: $this.find('.swiper-button-next')[0],
                    prevEl: $this.find('.swiper-button-prev')[0],
                },
                scrollbar: {
                    el: $this.find('.swiper-scrollbar')[0],
                    hide: false,
                    draggable: true,
                },
                breakpoints: {
                    767: {
                        freeMode: false,
                        slidesPerView: 3,
                        spaceBetween: 12,
                    },
                    968: {
                        freeMode: false,
                        slidesPerView: 4,
                        sliderPerGroup: 4,
                        spaceBetween: 12,
                    },
                },
                on: {
                    slideChange: function (swiper) {
                        updateVisibleSlides(swiper);
                    },
                    init: function (swiper) {
                        updateVisibleSlides(swiper);
                    },
                    resize(swiper) {
                        updateVisibleSlides(swiper);
                    }
                }
            });
        });
    }


    function updateVisibleSlides(swiper) {
        swiper.slides.forEach(slide => slide.classList.remove('slide-visible'));
        let count = swiper.params.slidesPerView;
        if (count === 'auto') {
            count = 1;
        }

        for (let i = swiper.activeIndex; i < swiper.activeIndex + count; i++) {
            if (swiper.slides[i]) {
                swiper.slides[i].classList.add('slide-visible');
            }
        }
    }

    productSlider();

    $(document).gp_ready(function () {
        productSlider();
    });
})(jQuery);
